import type { VFC } from 'react';

interface OriIconProps {
  color?: string;
  name: string;
  size: string;
}

export const OriIcon: VFC<OriIconProps> = ({ color, name, size }) => (
  <span
    className={`icon v-icon-${name}`}
    style={{ fontSize: size, color }}
  />
);
